// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"556":"94bcc7b1","985":"99218e89"}[chunkId] + ".chunk.js";
};